import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { api } from "../api/client";
import SkeletonCard from "../components/SkeletonCard";

const Conditions = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/conditions").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false));
    }, []);

    return (
        <div className="min-h-screen bg-white dark:bg-[#0B0B12]">
            <Navbar />
            <main className="mx-auto max-w-6xl px-6 py-12 lg:px-12">
                <p className="label-uppercase text-zinc-500">Shop by</p>
                <h1 className="mt-1 text-4xl font-semibold tracking-tight text-zinc-900 sm:text-5xl dark:text-zinc-50" style={{ letterSpacing: "-0.02em" }}>
                    Conditions
                </h1>
                <p className="mt-2 max-w-xl text-sm text-zinc-500">
                    Find the right medicines, supplements and devices grouped by the health condition they help with.
                </p>

                {loading ? (
                    <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        {Array.from({ length: 9 }).map((_, i) => <SkeletonCard key={i} />)}
                    </div>
                ) : (
                    <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="conditions-grid">
                        {items.map((c) => (
                            <Link
                                key={c.slug}
                                to={`/conditions/${c.slug}`}
                                className="group relative block overflow-hidden rounded-2xl border border-zinc-100 bg-white p-5 transition-shadow hover:shadow-md dark:bg-white/[0.03] dark:border-white/10"
                                data-testid={`condition-card-${c.slug}`}
                            >
                                <div className={`absolute -right-6 -top-6 h-20 w-20 rounded-full bg-gradient-to-br ${c.hero_color} opacity-30 transition-opacity group-hover:opacity-50`} />
                                <div className="relative">
                                    <span className="text-3xl" aria-hidden>{c.icon_emoji}</span>
                                    <p className="mt-3 font-medium text-zinc-900 dark:text-zinc-50">{c.name}</p>
                                    <p className="mt-1 text-xs text-zinc-500 line-clamp-2">{c.short_description}</p>
                                    <p className="mt-3 inline-flex items-center gap-1 rounded-full bg-zinc-100 px-2 py-0.5 text-[10px] font-medium text-zinc-700 dark:bg-white/10 dark:text-zinc-300">
                                        {c.product_count} product{c.product_count === 1 ? "" : "s"}
                                    </p>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </main>
            <Footer />
        </div>
    );
};

export default Conditions;
